import styled from 'styled-components'

import { minmedia } from '../../styles/media-queries'
import { black, gold, whitegray, white } from '../../styles/colors'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 1rem;
  p {
    position: relative;
    margin-bottom: 0;
    color: ${black};
    cursor: pointer;
    user-select: none;
    line-height: 1;
    margin-top: 0.25rem;
    max-width: calc(100% - 28px);
    ${minmedia.medium`
      margin-top: 0.25rem;
    `};
  }
`

export const StyledCheck = styled.div`
  width: 1rem;
  height: 1rem;
  padding-right: 1.75rem;
  position: relative;
  input[type='checkbox'] {
    visibility: hidden;
    appearance: none;
  }
  input[type='checkbox']:checked + label::after {
    opacity: 1;
  }
  input[type='checkbox']:checked + label {
    background: ${gold};
    ${minmedia.medium`
      background: ${gold};
    `};
  }
  label {
    cursor: pointer;
    position: absolute;
    width: 1.25rem;
    height: 1.25rem;
    top: 0;
    left: 0;
    background: ${whitegray};
    border-radius: 0.25rem;
    border: 1px solid ${gold};
    transition: all 0.5s;
    &::after {
      opacity: 0;
      content: '';
      position: absolute;
      width: 12px;
      height: 7px;
      background: transparent;
      top: 0.26rem;
      left: 0.2rem;
      border: 3px solid ${white};
      border-top: none;
      border-right: none;
      transform: rotate(-45deg);
    }
    ${minmedia.large`
      &:hover::after {
        opacity: 0.5;
      }
    `};
  }
`



// WEBPACK FOOTER //
// ./src/components/CheckBox/styles.js